import { createAction, props } from '@ngrx/store';

import { Breadcrumbs } from '../models/breadcrumbs.models';

import { ProductPublicModels } from '@features/products/product';

export const BreadCrumbsActionTypes = {
    INIT_BREADCRUMBS: '[Breadcrumbs] INIT_BREADCRUMBS',
    INIT_BREADCRUMBS_SUCCESS: '[Breadcrumbs] INIT_BREADCRUMBS_SUCCESS',
};

export const InitBreadcrumbs = createAction(
    BreadCrumbsActionTypes.INIT_BREADCRUMBS,
    props<{ categoryId: string; product?: ProductPublicModels.PublicProduct }>()
);
export const InitBreadcrumbsSuccess = createAction(
    BreadCrumbsActionTypes.INIT_BREADCRUMBS_SUCCESS,
    props<{ breadcrumbs: Breadcrumbs }>()
);
